import gql from 'graphql-tag';
import { apollo } from 'src/features';

const query = gql`
query sendConfirmationCode($login: String!){
      sendConfirmationCode(login: $login) {
       email
      }
    }`;

function getConfirmationCode(login) {
  return apollo.client.query({
    query,
    variables: {
      login,
    },
    fetchPolicy: 'network-only',
  }).then((data) => data.data.sendConfirmationCode)
    .catch((err) => {
      if (err.graphQLErrors.length) {
        throw err.graphQLErrors[0].error.code;
      } else {
        throw err;
      }
    });
}

export default getConfirmationCode;
